import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenManagerService } from './core/auth/token-manager.service';
import { ConfigurationService } from './core/conf/configuration.service';
import { AppConfiguration } from './app.configuration';
import { VisorService } from './shared/services/visor.service';
import { mergeMap, map, filter, takeUntil } from 'rxjs/operators';
import { TranslateService } from './shared/services/translate.service';
import { SidebarNavigationService } from './shared/services/sidebar-navigation.service';
import { StepperNavigationService } from './modules/venta';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { BrowserUtils, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'ticketing-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  window = window as any;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private config: AppConfiguration,
    private http: HttpClient,
    private tokenManager: TokenManagerService,
    private translate: TranslateService,
    private configuration: ConfigurationService,
    private visor: VisorService,
    private sidebarNav: SidebarNavigationService,
    private stepperService: StepperNavigationService,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private location: Location,
    private router: Router
  ) {
    /* const traerConexionPrivadaBody = {
      chClaveEmpresa: this.config.getConfig('chClaveEmpresa'),
      chNombreProyecto: this.config.getConfig('chNombreProyecto'),
      chEntornoConexion: this.config.getConfig('chEntornoConexion'),
      chOrigenConexion: this.config.getConfig('chOrigenConexion'),
    };
    this.http
      .post(
        `${this.config.getConfig('API_URL')}api/TraerConexionPrivada`,
        traerConexionPrivadaBody
      )
      .subscribe((data: any) => {
        this.tokenManager.currentConexionIdSubject.next(data.pkid);
        localStorage.setItem('conexionId', JSON.stringify(data.pkid));
        this.tokenManager
          .login(
            // this.config.getConfig('USER'),
            // this.config.getConfig('PASSWORD')
            this.config.getConfig('NUMSERIE'),
            traerConexionPrivadaBody.chNombreProyecto
          )
          .pipe(
            mergeMap((res) => {

              //Traer Proyecto Privada
              this.tokenManager.TraerProyectoPrivada().subscribe();

              //obtenemos el tpvPath de la aplicacion
              this.configuration.getTPVPathLocal();
              //asignamos el tpv obtenido desde el servicio
              let config = this.configuration.tpvPathLocalValue;
              //comprobamos si el tpv esta en uso para cargar los disponibles si no lo esta
              if (!this.configuration.tpvFisicoValue) {
                this.configuration.getTPVEnUso(config, null, false).subscribe();
              }
              return this.http
                .post(
                  `${this.config.getConfig(
                    'API_URL'
                  )}api/Configuracion/GetDatosTPVPath`,
                  {
                    ConexionIacpos: data.pkid,
                    VMPath: config,
                  }
                )
                .pipe(
                  map((TPVPath: any) => {
                    this.configuration.setDatosTPVPathValue(
                      TPVPath.DatosResult
                    );
                    this.stepperService.setDatosTPVPathValue(
                      TPVPath.DatosResult
                    );
                    return TPVPath.DatosResult;
                  })
                );
            })
          )
          .pipe(
            mergeMap((res: any) => {
              return this.configuration.getAppConfig(res.pkId).pipe(
                map(() => {
                  return res;
                })
              );
            })
          )
          .pipe(
            mergeMap((res) => {
              return this.configuration.getModulos().pipe(
                map((modulos) => {
                  this.sidebarNav.setSecciones(modulos);
                  return res;
                })
              );
            })
          )
          .subscribe(() => {
            this.http
              .post(
                `${this.config.getConfig(
                  'API_URL'
                )}api/Configuracion/GetDatosInicio`,
                {
                  ConexionIacpos: data.pkid,
                }
              )
              .subscribe((res: any) => {
                this.visor.setToBlank();
                this.http
                  .post(
                    `${this.config.getConfig(
                      'API_URL'
                    )}api/Maestros/GetDivisas`,
                    {
                      ConexionIacpos: data.pkid,
                      ISO: res.DatosResult.DivisaISO,
                    }
                  )
                  .subscribe((infoDivisa: any) => {
                    this.configuration.getInternetConfig().subscribe();
                    this.configuration.setDatosInicioValue(res.DatosResult);
                    this.configuration.setDivisasValue(
                      infoDivisa.DatosResult.ListaDivisas
                    );
                    this.translate.setLocale(res.DatosResult.Idioma);
                    this.translate.use(res.DatosResult.Idioma);

                    if (!localStorage.getItem('redirectPath')) {
                      const tpvConfig = this.configuration.tpvPathLocalValue;
                      localStorage.setItem('redirectPath', tpvConfig);
                    }

                    this.configuration.dataReady.next(true);
                  });
              });
          });
      }); */

    if (environment['HAS_LOGIN_MICROSOFT']) {
      this.msalBroadcastService.msalSubject$
          .pipe(
            filter((msg: EventMessage) => msg.eventType === EventType.HANDLE_REDIRECT_END)
          )
          .subscribe((event) => {
            console.log({
              message: 'MSAL Event Called',
              data: event,
              actualRoute: this.router.url
            });
            if (!this.configuration.hasLoginSuccessValue) {
              this.configuration.setLoadInitData(true);
            }
          });
    }
    this.configuration.loadInitData$.subscribe((load) => {
      if (load) {
        console.log({
          message: 'Cargando datos iniciales...',
          load
        })
        const traerConexionPrivadaBody = {
          chClaveEmpresa: this.config.getConfig('chClaveEmpresa'),
          chNombreProyecto: this.config.getConfig('chNombreProyecto'),
          chEntornoConexion: this.config.getConfig('chEntornoConexion'),
          chOrigenConexion: this.config.getConfig('chOrigenConexion'),
        };
        this.http
          .post(
            `${this.config.getConfig('API_URL')}api/TraerConexionPrivada`,
            traerConexionPrivadaBody
          )
          .subscribe((data: any) => {
            this.tokenManager.currentConexionIdSubject.next(data.pkid);
            localStorage.setItem('conexionId', JSON.stringify(data.pkid));
            this.tokenManager
              .login(
                // this.config.getConfig('USER'),
                // this.config.getConfig('PASSWORD')
                this.config.getConfig('NUMSERIE'),
                traerConexionPrivadaBody.chNombreProyecto
              )
              .pipe(
                mergeMap((res) => {
                  //Traer Proyecto Privada
                  this.tokenManager.TraerProyectoPrivada().subscribe();

                  //obtenemos el tpvPath de la aplicacion
                  this.configuration.getTPVPathLocal();
                  //asignamos el tpv obtenido desde el servicio
                  let config = this.configuration.tpvPathLocalValue;
                  //comprobamos si el tpv esta en uso para cargar los disponibles si no lo esta
                  if (!this.configuration.tpvFisicoValue) {
                    this.configuration
                      .getTPVEnUso(config, null, false)
                      .subscribe();
                  }
                  return this.http
                    .post(
                      `${this.config.getConfig(
                        'API_URL'
                      )}api/Configuracion/GetDatosTPVPath`,
                      {
                        ConexionIacpos: data.pkid,
                        VMPath: config,
                      }
                    )
                    .pipe(
                      map((TPVPath: any) => {
                        this.configuration.setDatosTPVPathValue(
                          TPVPath.DatosResult
                        );
                        this.stepperService.setDatosTPVPathValue(
                          TPVPath.DatosResult
                        );
                        return TPVPath.DatosResult;
                      })
                    );
                })
              )
              .pipe(
                mergeMap((res: any) => {
                  return this.configuration.getAppConfig(res.pkId).pipe(
                    map(() => {
                      return res;
                    })
                  );
                })
              )
              .pipe(
                mergeMap((res) => {
                  return this.configuration.getModulos().pipe(
                    map((modulos) => {
                      this.sidebarNav.setSecciones(modulos);
                      return res;
                    })
                  );
                })
              )
              .subscribe(() => {
                this.http
                  .post(
                    `${this.config.getConfig(
                      'API_URL'
                    )}api/Configuracion/GetDatosInicio`,
                    {
                      ConexionIacpos: data.pkid,
                    }
                  )
                  .subscribe((res: any) => {
                    this.visor.setToBlank();
                    this.http
                      .post(
                        `${this.config.getConfig(
                          'API_URL'
                        )}api/Maestros/GetDivisas`,
                        {
                          ConexionIacpos: data.pkid,
                          ISO: res.DatosResult.DivisaISO,
                        }
                      )
                      .subscribe((infoDivisa: any) => {
                        this.configuration.getInternetConfig().subscribe();
                        this.configuration.setDatosInicioValue(res.DatosResult);
                        this.configuration.setDivisasValue(
                          infoDivisa.DatosResult.ListaDivisas
                        );
                        this.translate.setLocale(res.DatosResult.Idioma);
                        this.translate.use(res.DatosResult.Idioma);

                        if (!localStorage.getItem('redirectPath')) {
                          const tpvConfig =
                            this.configuration.tpvPathLocalValue;
                          localStorage.setItem('redirectPath', tpvConfig);
                        }

                        this.configuration.dataReady.next(true);
                      });
                  });
              });
          });
      }
    });
  }

  ngOnInit(): void {
    const currentPath = this.location.path();
    // Dont perform nav if in iframe or popup, other than for front-channel logout

    if (environment['HAS_LOGIN_MICROSOFT']) {
      this.isIframe =
        BrowserUtils.isInIframe() &&
        !window.opener &&
        currentPath.indexOf('logout') < 0; // Remove this line to use Angular Universal
      this.setLoginDisplay();

      this.msalBroadcastService.inProgress$
        .pipe(
          filter(
            (status: InteractionStatus) => status === InteractionStatus.None
          ),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          console.log({
            message: 'InteractionStatus changed to None',
            activeAccount: this.authService.instance.getActiveAccount(),
            accounts: this.authService.instance.getAllAccounts(),
          });
          this.setLoginDisplay();
          this.checkAndSetActiveAccount();
        });
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);

      console.log({
        message: 'No active account set, setting first account as active',
        activeAccount: this.authService.instance.getActiveAccount(),
        accounts: this.authService.instance.getAllAccounts(),
      });
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
